import { render, staticRenderFns } from "./UpdateInterfaces.vue?vue&type=template&id=01355066"
import script from "./UpdateInterfaces.vue?vue&type=script&lang=js"
export * from "./UpdateInterfaces.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports